module.exports = "/_next/static/images/1dc8a172ab092973794a36589ddfa852-card.jpg.webp";